module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_schatzberg_sm-3b1d8113356a00cf1b2aff353fa21ffe.png";